import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SearchService } from '../services/search.service';
import { ApiService } from '../services/api.service';

@Component({
  selector: 'app-search-results',
  standalone:false,
  templateUrl: './search-results.component.html',
  styleUrl: './search-results.component.scss'
})
export class SearchResultsComponent {
searchQuery: string = '';
  searchResults: any;
  isLoading: boolean = false;
   flattenedResults: any[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private searchService: SearchService
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.searchQuery = params['q'] || '';
      if (this.searchQuery) {
        this.performSearch();
      }
    });
  }

  performSearch() {
    this.isLoading = true;
    this.searchService.search(this.searchQuery).subscribe({
      next: (response) => {
        this.searchResults = response.results;
        this.flattenResults();
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Search error:', err);
        this.isLoading = false;
      }
    });
  }

  flattenResults() {
    this.flattenedResults = [];
    for (const moduleName of this.objectKeys(this.searchResults)) {
      const moduleItems = this.searchResults[moduleName];
      for (const item of moduleItems) {
        this.flattenedResults.push({
          module: moduleName,
          model: item.model,
          pk: item.pk,
          fields: item.fields
        });
      }
    }
  }

  objectKeys(obj: any): string[] {
    return obj ? Object.keys(obj) : [];
  }
 goBack() {
    // Navigate back with clear flag
    this.router.navigate(['/'], { 
      state: { clearSearch: true } 
    });
    
  }
}
